module.exports = __webpack_public_path__ + "static/donation-draw-32dc571a5d8b7ffb4f12b1bfd6b5da64.svg";